var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@font-face {\nfont-family: \"Space Cruiser\";\nsrc: url(" + escape(require("../../assets/fonts/SPACEC6P.eot")) + ");\nsrc:\nurl(" + escape(require("../../assets/fonts/SPACEC6P.woff")) + ") format(\"woff\"),\n\nurl(" + escape(require("../../assets/fonts/SPACEC6P.svg")) + "#filename) format(\"svg\");\n}\n\n.front-page {\n  background-image: url('https://i.warosu.org/data/tg/img/0404/80/1433815544195.jpg');\n  background-size: cover;\n  height: 100vh;\n  text-align: center;\n}\n\n.title {\n  padding-top: 10vh;\n  font-size: 15vh;\n  color: rgba(152, 5, 5, .4);\n  text-shadow: 3vh 2vh rgba(152, 5, 5, 1);\n  font-family: 'Space Cruiser', Arial, sans-serif;\n}\n\n.start {\n  font-family: 'Space Cruiser', Arial, sans-serif;\n  font-size: 5vh;\n  color: rgba(152, 5, 5, 1);\n}\n\n.start:hover {\n  color: rgba(72, 3, 3, 0.69);\n}\n\n.login {\n  font-family: 'Space Cruiser', Arial, sans-serif;\n  font-size: 5vh;\n  color: rgba(152, 5, 5, 1);\n}\n\n.login:hover {\n  color: rgba(72, 3, 3, 0.69);\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/Guest/Desktop/Space-Janitor/src/app/front-page/front-page.component.css
// module id = ../../../../../src/app/front-page/front-page.component.css
// module chunks = main